<template>
	<div style="width: 100%;height: 100%;">
		<div v-if="!AttendSuccess&&!AttendWarning" style="width: 100%;height: 100%;">
			<div style="width: 100%;margin: 0 auto;text-align: center;margin-top: 30px;">
				<Icon size="120" color="#5cadff" type="ios-time" />
			</div>
			<div style="width: 100%;height: 38px;margin: 0 auto;text-align: center;font-size: 22px;">
				您确定<InputNumber :max="10" :min="1" style="width:45px" v-model="number"></InputNumber>人报名今日午餐?
			</div>
			<Row type="flex" justify="center" align="middle" style="margin-top: 12rem;">
				<Col span="2">
				</Col>
				<Col span="20">
					<Button style="margin-bottom: 12px;" type="success" long>确定</Button>
					<Button long>取消</Button>
				</Col>
				<Col span="2">
				</Col>
			</Row>
		</div>
		<div v-if="AttendSuccess||AttendWarning" style="width: 100%;height: 100%;padding-top: 30px;">
			<div style="width: 100%;margin: 0 auto;text-align: center;">
				<Icon size="120" :color="AttendSuccess?'#10b910':'#ed4014'" type="ios-checkmark-circle" />
			</div>
			<div style="width: 100%;height: 38px;margin: 0 auto;text-align: center;font-size: 28px;">
				{{AttendSuccess?'报名成功':''}}{{AttendWarning?WarningMsg:''}}
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		data(){
			return {
				number:1,
				AttendSuccess:false,
				AttendWarning:false,
				WarningMsg:'不可操作'
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/views/WeChat/Person/Eatery/Attend/index.vue